<template>
  <div class="testimonial-card-wrapper d-flex flex-column">
    <div class="testimonial-card shadow-default bg-white p-4 d-flex flex-column flex-wrap">
      <div class="testimonial-content text-center mb-2">
        <p>{{ text }}</p>
      </div>
      <div class="testimonial-info-wrap d-flex flex-wrap align-items-center justify-content-center">
        <div class="testimonial-image shadow-light mr-3" :style="`background-image: url('${person_image}');`"></div>
        <div class="testimonial-info">
          <h2 class="font-weight-bold font-size-regular text-color2 mb-0">{{ person_name }}</h2>
          <p class="mb-0 font-size-xSmall">{{ person_info }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestimonialCard',
  props: ['person_image', 'person_name', 'person_info', 'text']
}
</script>

<style lang="scss" scoped>
.testimonial-card {
  border-radius: 30px;
  max-width: 350px;
  position: relative;
  z-index: -2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 295px;

  .testimonial-image {
    width: 60px;
    height: 60px;
    border-radius: 100px;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    flex-shrink: 1;
  }
}
</style>
